function initMegaMenu() {
  console.log("✅ MegaMenu initialized!");

  // Remove any previous listeners
  document.removeEventListener("click", megaMenuHandler);

  document.addEventListener("click", megaMenuHandler);
}

function megaMenuHandler(e) {
  const arrow = e.target.closest(".dropdown-arrow");
  if (!arrow) return;

  // mobile / tablet only
  if (window.innerWidth > 1024) return;

  e.preventDefault();
  e.stopPropagation();

  const parentItem = arrow.closest(".mega-menu__item");
  if (!parentItem) return;

  const submenu = parentItem.querySelector(".mega-menu__sub-menu");
  if (!submenu) return;

  const isOpen = submenu.classList.contains("open");

  document.querySelectorAll(".mega-menu__sub-menu.open").forEach(el => {
    el.classList.remove("open");
  });

  if (!isOpen) {
    submenu.classList.add("open");
  }
}


// Re-init once DOM is ready AND once Shopify reloads header
document.addEventListener("DOMContentLoaded", () => {
  const interval = setInterval(() => {
    if (document.querySelector(".mega-menu__item")) {
      initMegaMenu();
      clearInterval(interval);
    }
  }, 300);
});

